var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Cloud component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCloud extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.1483 5.83779C9.92804 6.28124 9.18809 6.74716 8.67605 7.27393C8.16105 7.80374 7.82308 8.44925 7.49179 9.35296C7.39426 9.61901 7.15511 9.80738 6.87361 9.83987C5.24379 10.028 4.18226 10.6864 3.5334 11.4938C2.87581 12.3122 2.59646 13.3407 2.64133 14.333C2.73129 16.3225 4.39196 18.2937 6.70206 18.348L11.7492 18.3535C14.3659 18.3563 17.1591 18.3591 17.8683 18.3591C20.1609 18.3591 21.6664 16.2465 21.3352 14.3295C20.9876 12.3174 19.4777 11.5911 18.4687 11.3528C18.1615 11.2803 17.9326 11.0232 17.896 10.7096C17.4394 6.78812 14.0349 5.02166 11.1483 5.83779ZM6.88721 19.8478H6.67687C3.4789 19.7783 1.26413 17.0828 1.14286 14.4008C1.08369 13.0921 1.44934 11.6927 2.36413 10.5542C3.21507 9.4953 4.50301 8.70982 6.24572 8.4145C6.57637 7.59714 6.97898 6.86776 7.60046 6.22841C8.32665 5.48133 9.29813 4.91135 10.6625 4.41838C10.6782 4.41274 10.694 4.40761 10.7099 4.40302C14.3279 3.36151 18.5142 5.49184 19.313 10.0352C20.6152 10.4693 22.379 11.5603 22.8133 14.0742C23.2916 16.8429 21.1564 19.8591 17.8683 19.8591C17.1581 19.8591 14.3637 19.8563 11.7476 19.8535L6.88721 19.8478Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCloud.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCloud.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCloud.prototype, "size", void 0);
if (customElements.get('cat-icon-cloud') === undefined) {
    customElements.define('cat-icon-cloud', BlocksIconCloud);
}
